import React from "react";
import { useNavigate } from "react-router-dom";
import { PageHero, Section } from "@/components/PageParts";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useSettings } from "@/context/SettingsContext";
import { CheckCircle2 } from "lucide-react";

export default function BecomeProfessional() {
  const nav = useNavigate();
  const settings = useSettings();
  return (
    <div>
      <PageHero eyebrow="Path 1 — Placement Professional" title="Become a placement professional"
        subtitle="Learn the system and, once approved, apply for independent placement opportunities with participating providers. You are not automatically an employee, and income is never guaranteed." />
      <Section className="py-20">
        <div className="grid gap-12 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-3xl font-semibold tracking-tight text-navy">What you get</h2>
            <ul className="mt-6 space-y-4">
              {["Structured curriculum built around the Skool community",
                "CRM with leads, pipeline, attribution & duplicate protection",
                "AI assistant for outreach, scripts, and follow-up",
                "Provider network and available care capacity search",
                "Commission opportunity center & interactive calculator",
                "Gamified milestones as you develop your business"].map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emeraldbrand" />
                  <span className="text-slate-600">{p}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button data-testid="become-apply-btn" onClick={() => nav("/join")} className="bg-clinical hover:bg-clinical/90">
                Apply to become a placement professional
              </Button>
            </div>
          </div>
          <Card className="p-8">
            <h3 className="font-heading text-xl font-semibold text-navy">How approval works</h3>
            <ol className="mt-5 space-y-4">
              {[["Apply", "Complete the placement professional application with your background and acknowledgments."],
                ["Review", "Applications are reviewed manually — we do not automatically approve agents."],
                ["Agreement", "Approved applicants complete required written arrangements."],
                ["Activate", "Your dashboard unlocks with onboarding tasks and opportunities."]].map(([t, d], i) => (
                <li key={t} className="flex gap-4">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-navy font-heading text-sm font-bold text-white">{i + 1}</span>
                  <div>
                    <p className="font-semibold text-navy">{t}</p>
                    <p className="text-sm text-slate-500">{d}</p>
                  </div>
                </li>
              ))}
            </ol>
            <p className="mt-6 rounded-lg bg-amberbrand/10 p-4 text-xs text-slate-600">
              Membership is {settings.membership_price}, hosted and paid through Skool. Compensation depends on approved
              written provider agreements and applicable law.
            </p>
          </Card>
        </div>
      </Section>
    </div>
  );
}
